export enum WidgetType {
    ConvoList = 'convo-list',
    MediaObject = 'media-object',
    Hero = 'hero',
    HeroSubscriber = 'hero-subscriber',
    DailyChatOpinion = 'daily-chat-opinion',
    AbTest = 'ab-test',
}
